import { api, publicApi } from '../lib/api'
import { clearFlow, startFlow } from '../telemetry/flow'
import { getClientRequestId } from '../telemetry/request'

export type HandleCheckApiResponse = {
  normalized: string
  search_key?: string
  format_class?: string
  state: string
  score: number
  tier: string
  price: number
  breakdown?: Record<string, number>
  expires_at?: string | null
}

export async function checkHandle(value: string): Promise<HandleCheckApiResponse> {
  const { data } = await publicApi.get<HandleCheckApiResponse>('/api/handles/check', {
    params: { handle: value },
  })
  return data
}

export type HandleReservation = {
  reservation_id: number
  state: string
  price: number
  expires_at: string
}

export async function reserveHandle(handle: string, holdSeconds = 600): Promise<HandleReservation> {
  const flow = startFlow('handle_reserve')
  const headers = {
    'X-Client-Action': 'handle_reserve',
    'X-Client-Flow-Id': flow.flowId,
    'X-Client-Request-Id': getClientRequestId(),
  }
  try {
    const { data } = await api.post<HandleReservation>(
      '/api/handles/reserve',
      { handle, hold_seconds: holdSeconds },
      { headers },
    )
    return data
  } finally {
    clearFlow(flow.flowId)
  }
}

export async function claimHandle(reservationId: number, paymentRef = 'free') {
  const flow = startFlow('handle_claim')
  const headers = {
    'X-Client-Action': 'handle_claim',
    'X-Client-Flow-Id': flow.flowId,
    'X-Client-Request-Id': getClientRequestId(),
  }
  try {
    const { data } = await api.post(
      '/api/handles/claim',
      { reservation_id: reservationId, payment_ref: paymentRef },
      { headers },
    )
    return data
  } finally {
    clearFlow(flow.flowId)
  }
}

export type HandlePurchaseResponse = {
  reservation_id: number
  payment_ref: string
  price_cents: number
  price_pixe: string
  balance_pixe: string
  deficit_pixe?: string | null
}

export async function purchaseHandle(reservationId: number): Promise<HandlePurchaseResponse> {
  const { data } = await api.post<HandlePurchaseResponse>('/api/handles/purchase', {
    reservation_id: reservationId,
  })
  return data
}
